var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-layout d-flex align-items-center justify-content-center m-0 bg-white",attrs:{"id":"intro"}},[_c('img',{attrs:{"id":"twoimgintro","src":"/img/home_down.gif"}}),_vm._v(" "),_c('img',{attrs:{"id":"oneimgintro","src":"/img/home_up.gif"}}),_vm._v(" "),_c('child')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a546c65a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/basic.vue
// module id = null
// module chunks = 